// removed by extract-text-webpack-plugin
module.exports = {"ba-modal-card":"magazines_1FKyk","ba-modal-card__title":"magazines_2rM3b","ba-modal-card__button__error":"magazines_z4w7d","ba-modal-card__button__info":"magazines_2DKiz","ba-modal-card__button__success":"magazines_1j-2N","ba-modal-card__button__alert":"magazines_JB3Y8","wrapper-alert-modal":"magazines_3T5U9","wrapper-alert-modal-buttons":"magazines_2bNBJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AlertModal/styles.scss
// module id = 1021
// module chunks = 1